import { useEffect, useState } from 'react';
import { SectionDto, TierDto } from 'legacy/events/types';
import isEqual from 'lodash/isEqual';
/**
 * This hook manages the state for ticket creation and edit while handling the Event Form.
 */
const useManageTickets = (
  initialTiers?: Array<TierDto>,
  initialSections?: Array<SectionDto>
) => {
  const [tickets, setTickets] = useState<Array<TierDto>>(initialTiers);
  const [sections, setSections] = useState<Array<SectionDto>>(initialSections);

  useEffect(() => {
    if (!isEqual(tickets, initialTiers)) {
      setTickets(initialTiers);
    }
  }, [initialTiers]);

  useEffect(() => {
    if (!isEqual(sections, initialSections)) {
      setSections(initialSections);
    }
  }, [initialSections]);

  const [selectedIndex, setSelectedIndex] = useState(null);
  const [selectedTicket, setSelectedTicket] = useState(null);

  const addTicket = (ticket: TierDto) => {
    setTickets([...tickets, ticket]);
  };

  const deleteTicket = (id: string) => {
    setTickets(
      tickets.filter((ticket: any) => {
        const ticketId = ticket._id || ticket.id;

        return id !== ticketId;
      })
    );
  };

  const updateTicket = (id: string, values: TierDto) => {
    setTickets(
      tickets.map((ticket: any) => {
        const ticketId = ticket.id;

        if (ticketId === id) {
          return values;
        }

        return ticket;
      })
    );
  };

  const toggleTicket = ({ id, isDisabled }) => {
    setTickets(
      tickets.map((ticket: any) => {
        const ticketId = ticket._id || ticket.id;

        if (id === ticketId) {
          return { ...ticket, isDisabled };
        }

        return ticket;
      })
    );
  };

  const enableTicket = (id: string) => {
    toggleTicket({ id, isDisabled: false });
  };

  const disableTicket = (id: string) => {
    toggleTicket({ id, isDisabled: true });
  };

  return {
    tickets,
    addTicket,
    updateTicket,
    deleteTicket,
    enableTicket,
    disableTicket,
    setTickets,

    selectedTicket,
    setSelectedTicket,

    selectedIndex,
    setSelectedIndex,

    sections,
    setSections
  };
};

export default useManageTickets;
